import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFavouritesSummary } from '@noths/polaris-client-user-favourites';

import {
  adaptStoreToNextPageURL,
  adaptStoreToPreviousPageURL,
} from 'src/adapters/storeToPageURL/adaptStoreToPaginationURL';
import { ProductPages } from 'src/components/organisms/ProductPages/components/ProductPages';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { updatePageURLWithQuery } from 'src/redux/products/thunks/updatePageURLWithQuery';
import { TriggerName } from 'src/redux/products/types';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';

export const ProductPagesContainer = () => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const state = useSelector((state: ReduxApplicationState) => state);
  const isLoading = state.products.pageLoading !== null;
  const loadPreviousURL = adaptStoreToPreviousPageURL(state);
  const loadMoreURL = adaptStoreToNextPageURL(state);
  const pageLoading = state.products.pageLoading;
  const productsByPage = state.products.pages;
  const favouriteProductCodes = selectFavouritesSummary(state).productCodes;
  const totalProducts = selectTotalProducts(state);

  const onLoadPrevious = ({ page }: { page: number }) => {
    dispatch(actions.changePage(page - 1));
    dispatch(requestProducts({ triggerName: TriggerName.LOAD_PREVIOUS_PRODUCTS }));
    dispatch(updatePageURLWithQuery());
  };

  const onLoadMore = ({ page }: { page: number }) => {
    dispatch(actions.changePage(page + 1));
    dispatch(requestProducts({ triggerName: TriggerName.LOAD_MORE_PRODUCTS }));
    dispatch(updatePageURLWithQuery());
  };

  return (
    <ProductPages
      favouriteProductCodes={favouriteProductCodes}
      isLoading={isLoading}
      loadMoreURL={loadMoreURL}
      loadPreviousURL={loadPreviousURL}
      onLoadMore={onLoadMore}
      onLoadPrevious={onLoadPrevious}
      pageLoading={pageLoading}
      productsByPage={productsByPage}
      totalProducts={totalProducts}
    />
  );
};
